import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../../../dishAssignmentState/dishAssignmentContext';
import Button from 'components/Button/Button';
import { DownOutlined } from '@ant-design/icons';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import style from './BottomControlPanel.module.scss';

export const BottomControlPanel: React.FC = () => {
	const {
		changeActiveItemToDisplay,
		changeIsShowModalWindowToCreateSubcategory,
		activeItemToDisplay,
		IDsSelectedCategories,
		IDsSelectedSubcategories,
	} = useContext<IDishAssignmentContext>(DishAssignmentContext);

	const createSubcategoryBtnClasses = classNames(style.createSubcategoryBtn, {
		[style.show]: activeItemToDisplay === 'subCategories',
	});
	const goOnBtnClasses = classNames({
		[style.hide]: activeItemToDisplay === 'dishes',
	});

	const handleGoBack = () => {
		if (activeItemToDisplay === 'subCategories') {
			changeActiveItemToDisplay('categories');
		} else if (activeItemToDisplay === 'dishes') {
			changeActiveItemToDisplay('subCategories');
		}
	};

	const handleGoOn = () => {
		if (activeItemToDisplay === 'categories') {
			changeActiveItemToDisplay('subCategories');
		} else if (activeItemToDisplay === 'subCategories') {
			changeActiveItemToDisplay('dishes');
		}
	};

	return (
		<div className={style.container} data-test="BottomControlPanel">
			{activeItemToDisplay === 'subCategories' && (
				<Button
					className={createSubcategoryBtnClasses}
					onClick={() => changeIsShowModalWindowToCreateSubcategory(true)}
					iconPosition="post"
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#plus`} />
						</svg>
					}>
					<Text translationNameSpace="listing" translationKey="createSubcategoryLabel" asFragment={true} />
				</Button>
			)}

			<div className={style.buttonWrapper}>
				<Button
					theme="outlined"
					onClick={handleGoBack}
					disabled={activeItemToDisplay === 'categories'}
					icon={<DownOutlined className={style.iconLeft} rotate={90} />}>
					<Text translationNameSpace="listing" translationKey="goBackLabel" asFragment={true} />
				</Button>

				{/* <Button
					className={createSubcategoryBtnClasses}
					onClick={() => changeIsShowModalWindowToCreateSubcategory(true)}
					iconPosition="post"
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#plus`} />
						</svg>
					}>
					<Text translationNameSpace="listing" translationKey="createSubcategoryLabel" asFragment={true} />
				</Button> */}

				<Button
					className={goOnBtnClasses}
					theme="primaryBlue"
					onClick={handleGoOn}
					disabled={
						(activeItemToDisplay === 'categories' && !Object.keys(IDsSelectedCategories).length) ||
						(activeItemToDisplay === 'subCategories' && !Object.keys(IDsSelectedSubcategories).length) ||
						activeItemToDisplay === 'dishes'
					}
					iconPosition="post"
					icon={<DownOutlined className={style.iconRight} rotate={270} />}>
					<Text translationNameSpace="listing" translationKey="goOnLabel" asFragment={true} />
				</Button>
			</div>
		</div>
	);
};
